(function ($, window) {
    'use strict';
    $(document).ready(function () {
        $(document).on('hidden.bs.modal', '.modal', function () {
            if ($(document.activeElement).closest('.modal').length) {
                $(document.activeElement).blur();
            }
        });
    });
})(jQuery, window);
